if ("undefined" == typeof debounce)
  function debounce(e, t) {
    let s;
    return (...n) => {
      clearTimeout(s), (s = setTimeout(() => e.apply(this, n), t));
    };
  }
if (!customElements.get("theme-header")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.header_section = document.querySelector(".header-section")),
        (this.menu = this.querySelector("#mobile-menu")),
        (this.toggle = document.querySelector(".mobile-toggle-wrapper")),
        document.addEventListener("keyup", (e) => {
          e.code &&
            "ESCAPE" === e.code.toUpperCase() &&
            (this.toggle.removeAttribute("open"),
            this.toggle.classList.remove("active"));
        }),
        this.toggle
          .querySelector(".mobile-toggle")
          .addEventListener("click", (e) => {
            this.toggle.classList.contains("active")
              ? (e.preventDefault(),
                document.body.classList.remove("overflow-hidden"),
                this.toggle.classList.remove("active"),
                this.closeAnimation(this.toggle))
              : (document.body.classList.add("overflow-hidden"),
                setTimeout(() => {
                  this.toggle.classList.add("active");
                })),
              window.dispatchEvent(new Event("resize.resize-select"));
          }),
        (this._scrollRaf = null),
        (this._onScroll = () => {
          this._scrollRaf ||
            (this._scrollRaf = window.requestAnimationFrame(() => {
              (this._scrollRaf = null),
                this.setStickyClass(),
                this.setHeaderOffset(),
                this.setHeaderHeight();
            }));
        }),
        window.addEventListener("scroll", this._onScroll, { passive: !0 }),
        window.dispatchEvent(new Event("scroll")),
        document.querySelector(".announcement-bar-section") &&
          (window.addEventListener("scroll", this.setAnnouncementHeight(), {
            passive: !0,
          }),
          window.dispatchEvent(new Event("resize"))),
        this.menu
          .querySelectorAll("summary")
          .forEach((e) =>
            e.addEventListener("click", this.onSummaryClick.bind(this))
          ),
        this.menu
          .querySelectorAll(".parent-link-back--button")
          .forEach((e) =>
            e.addEventListener("click", this.onCloseButtonClick.bind(this))
          );
    }
    setStickyClass() {
      if (this.classList.contains("header-sticky--active")) {
        let e =
          parseInt(this.getBoundingClientRect().top, 10) +
          document.documentElement.scrollTop;
        this.classList.toggle(
          "is-sticky",
          window.scrollY >= e && window.scrollY > 0
        );
      }
    }
    setAnnouncementHeight() {
      let e = document.getElementById("shopify-section-announcement-bar");
      if (e) {
        let t = e.clientHeight;
        document.documentElement.style.setProperty(
          "--announcement-height",
          t + "px"
        );
      }
    }
    setHeaderOffset() {
      let e = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty("--header-offset", e + "px");
    }
    setHeaderHeight() {
      let e = this.clientHeight;
      document.documentElement.style.setProperty("--header-height", e + "px");
    }
    onSummaryClick(e) {
      let t = e.currentTarget,
        s = t.parentNode,
        n = s.closest(".link-container");
      s.hasAttribute("open"),
        this.querySelector(".parent-link-back--button") &&
          (this.menu.scrollTop = 0),
        setTimeout(() => {
          s.classList.add("menu-opening"), n && n.classList.add("submenu-open");
        }, 100);
    }
    onCloseButtonClick(e) {
      e.preventDefault();
      let t = e.currentTarget.closest("details");
      this.closeSubmenu(t);
    }
    closeSubmenu(e) {
      e.classList.remove("menu-opening"), this.closeAnimation(e);
    }
    closeAnimation(e) {
      let t,
        s = (n) => {
          void 0 === t && (t = n);
          let i = n - t;
          i < 400 ? window.requestAnimationFrame(s) : e.removeAttribute("open");
        };
      window.requestAnimationFrame(s);
    }
  }
  customElements.define("theme-header", e);
}
if (!customElements.get("full-menu")) {
  class t extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (
        ((this.submenus = this.querySelectorAll(
          ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"
        )),
        !this.submenus.length)
      )
        return;
      let e = this;
      window.addEventListener(
        "resize",
        debounce(function () {
          e.resizeSubMenus();
        }, 100)
      ),
        window.dispatchEvent(new Event("resize")),
        document.fonts.ready.then(function () {
          e.resizeSubMenus();
        });
    }
    resizeSubMenus() {
      this.submenus.forEach((e) => {
        e.querySelectorAll(":scope >.menu-item-has-children>.sub-menu").forEach(
          (e) => {
            let t;
            e.offsetWidth +
              (e.parentElement.parentElement.getBoundingClientRect().left +
                e.parentElement.parentElement.clientWidth +
                10) >
            document.body.clientWidth
              ? e.parentElement.classList.add("left-submenu")
              : e.parentElement.classList.contains("left-submenu") &&
                e.parentElement.classList.remove("left-submenu");
          }
        );
      });
    }
  }
  customElements.define("full-menu", t);
}
